import { Box, BoxProps, CircularProgress } from "@mui/material";

export default function CentredSpinnerBox(props: BoxProps) {
  return (
    <Box
      display="flex"
      height="100%"
      width="100%"
      alignItems="center"
      justifyContent="center"
      {...props}
    >
      <CircularProgress />
    </Box>
  );
}
